import React, { Component } from 'react';
import Footer from '../footer/newfooter';
import Header from '../header/newheader';
import TopBar from '../topbar/topbar'
import ReactHtmlParser from 'react-html-parser';
import Loader from 'react-loader'
import queryString from 'query-string'
import cachios from 'cachios';
import Axios from 'axios';
import { Link } from 'react-router-dom'
import { BASE } from "../api/api";
import Highlighter from "react-highlight-words";
import pdf from '../assets/Download.png'
import htmlToText from 'html-to-text'
import { getName } from 'country-list'
import printJS from 'print-js';
import load from '../assets/loading.gif'
import back from '../assets/back.png'
import './sub.css'

class Innerbook extends Component {
    constructor(props) {
        super(props);
        this.state = {
            included: '',
            nids: [],
            refer: [],
            journal: [],
            inst: [],
            descr: [],
            authors: [],
            affl: [],
            booktitle: [],
            publisher: [],
            related: [],
            conf: [],
            pdf: [],
            journal_img: [],
            loader: true,
            articletype: '',
            booktype: '',
            chaptype: '',
            conftype: '',
            thesistype: '',
            newnids: [],
            nid: props.match.params.nid,
            scroll: props.match.params.anchor,
            index1: queryString.parse(this.props.location.search).search === "true" ? JSON.parse(localStorage.getItem('indexof')) : '',
            lowerlimit: queryString.parse(this.props.location.search).search === "true" ? (JSON.parse(localStorage.getItem('cisarray'))).length * (-1) : '',
            loginred: queryString.parse(this.props.location.search).search ? '/login?redir=' + props.location.pathname + '?search=' + queryString.parse(this.props.location.search).search : '/login?redir=' + props.location.pathname,
            queryobj: queryString.parse(props.location.search),
            cf: queryString.parse(this.props.location.search).search === "true" ? localStorage.getItem('keyword') : '',
            keyarr: queryString.parse(this.props.location.search).search === "true" ? JSON.parse(localStorage.getItem('keyarr')) : '',
            cisstring: queryString.parse(this.props.location.search).search === "true" ? JSON.parse(localStorage.getItem('cisstring')) : '',
            filter: queryString.parse(this.props.location.search).search === "true" ? JSON.parse(localStorage.getItem('filterof')) : '',
            prevnid: true,
            nextnid: true,
            cisarray: queryString.parse(this.props.location.search).search === "true" ? JSON.parse(localStorage.getItem('cisarray')) : '',
        };
    }

    checknext() {
        if (this.state.index === this.state.sarray.length - 1) {
            this.setState({ nextpage: false })
        }
        else {
            this.setState({ nextpage: true })
        }
    }

    clearinc() {
        this.setState({
            reljournal: '',
            relauthor: '',
            relpublisher: '',
            refer: [],
            journal: [],
            inst: [],
            descr: [],
            authors: [],
            book_name: [],
            affl: [],
            sub_data: '',
            loader: true,
            related: [],
            refernew: [],
            publisher: [],
            conf: [],
            img: '',

        })
    }

    componentWillReceiveProps(nextProps) {
        this.apicall(nextProps.match.params.nid)
    }

    scroll() {
        var scrollingElement = (document.scrollingElement || document.body);
        scrollingElement.scrollTop = scrollingElement.scrollHeight;
    }

    worktypes() {
        Axios.get(`${BASE}jsonapi/node/faculty`)
            .then(data => {
                this.setState({
                    faculty: data.data.data
                })
            })
            .catch(err => {
                console.log("faculty err", err)
            })
        cachios.get(BASE + 'jsonapi/taxonomy_term/submit_for_work_types', {
            ttl: 500 /* seconds */,
        })
            .then((data) => {
                console.log(data.data.data, 'chk')
                data.data.data.map((value, ind) => {
                    if (value.attributes.name === 'Articles') {
                        this.setState({
                            articletype: value.id
                        })
                    }
                    else if (value.attributes.name === 'Books') {
                        this.setState({
                            booktype: value.id
                        })
                    }
                    else if (value.attributes.name === 'Book Chapters') {
                        this.setState({
                            chaptype: value.id
                        })
                    }
                    else if (value.attributes.name === 'Thesis') {
                        this.setState({
                            thesistype: value.id
                        })
                    }
                    else if (value.attributes.name === 'Conferences') {
                        this.setState({
                            conftype: value.id
                        })
                    }
                })
            })
        console.log(this.state.articletype, this.state.booktype, this.state.chaptype, this.state.thesistype, this.state.conftype, 'chk')
    }

    goto(nid, name, title) {
        let login = localStorage.getItem('token');
        if (login && login != null) {
            if (name != undefined)
                return '/publication/' + nid
        }
        else {
            return '/login?redir=/publication/' + nid
        }
    }



    goto2(id, nid, title) {

        return '/publication/' + nid

    }

    journlink(nid, title, type) {
        return '/content/' + title + '/' + type + '/' + nid
    }

    inst(nid, title) {
        return '/taxonomy/' + title + '/' + nid
    }

    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    getauthor(id) {
        cachios.get(BASE + 'jsonapi/node/submit_for_work?include=field_select_work_to_submit,field_author,field_journal,field_publisher&filter[title][condition][path]=id&filter[title][condition][operator]=CONTAINS&filter[title][condition][value]=' + id, {
            ttl: 500 /* seconds */,
        })
            .then((data) => {
                console.log(data.data.included, 'xxzz')
                {
                    data.data.included ? data.data.included.map((include, index) => {
                        if (include.type === "node--journals") {
                            this.setState({
                                reljournal: include.attributes
                            })
                        }
                        else if (include.type === "node--biographies") {
                            let arr = this.state.relauthor ? this.state.relauthor : []
                            arr.push(include.attributes)
                            this.setState({
                                relauthor: arr
                            })
                        }
                        else if (include.type === "taxonomy_term--publisher") {
                            this.setState({
                                relpublisher: include.attributes
                            })
                        }
                    })
                        : this.setState({
                            reljournal: '',
                            relauthor: '',
                            relpublisher: ''
                        })
                }
            })
    }


    logincheck() {
        let login = localStorage.getItem('token');
        if (login && login != null) {
            return true
        }
        else {
            this.props.history.push(this.state.loginred)
        }
    }

    apicall(nid) {
        this.setState({
            journal_img: [],
            pdf: []
        })
        cachios.get(BASE + 'jsonapi/node/submit_for_work?include=field_select_work_to_submit,field_image,field_conference,field_publisher,field_affliations,field_author,field_references,field_descriptors,field_full_text_pdf,field_institution,field_journal,field_journal.field_image,field_books.field_image&filter[drupal_internal__nid]=' + nid, {
            ttl: 500 /* seconds */,
        })
            .then((data) => {
                console.log(data, 'body')
                if (data.data.data.length === 0) {
                    this.props.history.push('/404')
                }
                this.setState({
                    included_data: data.data.included
                })
                this.topFunction()
                this.refreshexp()
                console.log("typeee", data.data.included.filter(item => item.type === "taxonomy_term--submit_for_work_types")[0].attributes.name)
                this.setState({
                    publication_type: data.data.included.filter(item => item.type === "taxonomy_term--submit_for_work_types")[0].attributes.name,
                    sub_data: data.data.data[0].attributes,
                    loader: false,
                    book_name: data.data.data[0].relationships.field_books.data,
                    reflength: data.data.data[0].relationships.field_references.data.length,
                    body: htmlToText.fromString('<h1>Hello World</h1>', {
                        wordwrap: 130
                    })
                })
                console.log('xxxxx', data.data.data[0].relationships.field_references.data.length)
                console.log('book_name', data.data.data[0].relationships.field_books.data)
                {
                    data.data.included ? data.data.included.map((include, index) => {
                        if (include.type === "node--submit_for_work") {
                            let refer = this.state.refer
                            if (include.relationships.field_image.data) {
                                let journal_img = BASE + data.data.included.filter(item => item.id === include.relationships.field_image.data.id)[0].attributes.uri.url
                                let journal_img_array = this.state.journal_img
                                journal_img_array.push(journal_img)
                                this.setState({
                                    journal_img: journal_img_array
                                })
                            }
                            console.log(include, 'xxxzzz')
                            if (this.state.related.length === 0) {
                                let related = this.state.related
                                this.getauthor(include.id)
                                related.push(include)
                                console.log("related", include)
                                this.setState({
                                    related: related

                                })
                                console.log(nids, 'xxxxx')

                            }
                            let nids = this.state.nids
                            nids.push(include.attributes.drupal_internal__nid)
                            refer.push(include)
                            this.setState({
                                refer: refer,
                                nids: nids
                            })
                            if (this.state.nids.length === this.state.reflength) {
                                let i, filter = []
                                for (i = 0; i < nids.length; i++) {
                                    filter.push('f[' + i + ']=nid:' + nids[i])
                                }
                                console.log(nids, 'xxxxx')
                                console.log(BASE + 'api/search?Keyword=*&from=0&size=100&' + filter.join('&'), 'xxxxx')
                                if (filter.length === nids.length)
                                    cachios.get(BASE + 'api/search?Keyword=*&from=0&size=100&' + filter.join('&'), {
                                        ttl: 500 /* seconds */,
                                    })
                                        .then((data) => {
                                            console.log(data, 'xxxxx')
                                            this.setState({
                                                refernew: data.data.hits.hits
                                            })

                                            // this.setState({
                                            //     sub_data: data.data.data[0].attributes,
                                            //     loader: false,
                                            //     reflength:data.data.data[0].relationships.field_references.data.length
                                            // })
                                        })
                            }
                            if (this.state.scroll)
                                this.scroll()
                        }
                        else if (include.type === "node--journals") {
                            let journal = this.state.journal
                            journal.push(include)
                            this.setState({
                                journal: journal
                            })
                            if (include.relationships.field_image.data) {
                                let journal_img = BASE + data.data.included.filter(item => item.id === include.relationships.field_image.data.id)[0].attributes.uri.url
                                let journal_img_array = this.state.journal_img
                                journal_img_array.push(journal_img)
                                this.setState({
                                    journal_img: journal_img_array
                                })
                            }
                            if (this.state.scroll)
                                this.scroll()
                        }
                        else if (include.type === "node--biographies") {
                            let authors = this.state.authors
                            authors.push(include)
                            this.setState({
                                authors: authors
                            })
                            if (this.state.scroll)
                                this.scroll()
                        }
                        else if (include.type === "file--image") {
                            console.log(data.data.data[0].relationships, "jounaldata")
                            if (data.data.data[0].relationships.field_journal.data) {
                                console.log("imgdata", include)
                                if (data.data.included.filter(item => item.type === "node--journals")[0].relationships.field_image.data) {
                                    if (include.id === data.data.included.filter(item => item.type === "node--journals")[0].relationships.field_image.data.id) {
                                        let journal_img = BASE + data.data.included.filter(item => item.id === include.relationships.field_image.data.id)[0].attributes.uri.url
                                        let journal_img_array = this.state.journal_img
                                        journal_img_array.push(journal_img)
                                        this.setState({
                                            journal_img: journal_img_array
                                        })
                                    }
                                    else {
                                        this.setState({
                                            img: BASE + include.attributes.uri.url
                                        })
                                    }
                                }
                                else {
                                    this.setState({
                                        img: BASE + include.attributes.uri.url
                                    })
                                }
                            }
                            else {
                                this.setState({
                                    img: BASE + include.attributes.uri.url
                                })
                            }

                            if (this.state.scroll)
                                this.scroll()
                        }
                        else if (include.type === "node--conference") {
                            let conf = this.state.conf
                            conf.push(include)
                            this.setState({
                                conf: conf
                            })
                            if (this.state.scroll)
                                this.scroll()
                        }
                        else if (include.type === "taxonomy_term--university_college") {
                            let inst = this.state.inst
                            inst.push(include)
                            console.log(include, "inst123")
                            this.setState({
                                inst: inst
                            })
                            if (this.state.scroll)
                                this.scroll()
                        }
                        else if (include.type === "taxonomy_term--descriptors") {
                            let descr = this.state.descr
                            descr.push(include)
                            this.setState({
                                descr: descr
                            })
                            if (this.state.scroll)
                                this.scroll()
                        }
                        else if (include.type === "taxonomy_term--affiliations") {
                            let affl = this.state.affl
                            affl.push(include)
                            this.setState({
                                affl: include
                            })
                            console.log('affiliations', affl)
                            if (this.state.scroll)
                                this.scroll()
                        }

                        else if (include.type === "taxonomy_term--publisher") {
                            let publisher = this.state.publisher
                            publisher.push(include)
                            console.log("pubb", publisher)
                            this.setState({
                                publisher: include
                            })
                            console.log('affiliations', this.state.publisher)
                            if (this.state.scroll)
                                this.scroll()
                        }
                        else if (include.type === "file--document") {
                            console.log("pdff", include.attributes.uri.url)
                            let item = include.attributes.uri.url
                            let arr = this.state.pdf
                            let pdfname = this.state.pdfname ? this.state.pdfname : []
                            if (arr.indexOf(item) === -1) {
                                arr.push(BASE + item);
                                pdfname.push(include.attributes.filename)
                            }
                            this.setState({
                                pdf: arr,
                                pdfname: pdfname
                            })
                            if (this.state.scroll)
                                this.scroll()
                        }
                    })


                        : this.setState({
                            refer: [],
                            journal: [],
                            inst: [],
                            descr: [],
                            authors: [],
                            affl: []

                        })
                }

            })
            .catch((err) => {
                console.log('include', err)
            })
    }

    signout() {
        localStorage.removeItem('token');
        localStorage.removeItem('expirytime');
        localStorage.removeItem('expiryref');
        let red = queryString.parse(this.props.location.search).search ? '/login?redir=' + this.props.location.pathname + '?search=' + queryString.parse(this.props.location.search).search : '/login?redir=' + this.props.location.pathname
        this.props.history.push(red)


    }


    refreshexp() {
        let s = new Date();
        s.setSeconds(s.getSeconds() + 1800);
        localStorage.setItem('expiryref', s)
    }


    checkexpiry() {
        if (localStorage.getItem('expiryref')) {
            let expref = Date.parse(localStorage.getItem('expiryref'))
            let s = new Date();
            if (s > expref) {
                this.signout()
            }
            else {
                this.refreshexp()
            }

        }
        else {
            this.signout()

        }
    }
    componentWillMount() {
        let login = localStorage.getItem('token');
        this.newnid()
        this.worktypes()
        let nid = this.state.nid
        this.topFunction()
        this.apicall(this.props.match.params.nid)
    }
    newnid() {
        let index
        Axios.get(BASE + 'jsonapi/node/submit_for_work?filter[cis][condition][path]=field_cis_publications&filter[cis][condition][value]=1&filter[titleFilter][condition][path]=field_select_work_to_submit.name&filter[titleFilter][condition][value]=Books&filter[title][condition][path]=title&filter[title][condition][path]=title&filter[title][condition][operator]=CONTAINS&sort=-field_year')
            .then((data) => {
                console.log('newnid', data.data.data)
                let nids = []
                data.data.data.map(data => {
                    nids.push(data.attributes.drupal_internal__nid)
                })
                this.setState({
                    newnids: nids
                })
                console.log('newnids', this.state.newnids)
                const current = JSON.parse(this.props.match.params.nid)
                index = this.state.newnids.findIndex(x => x === current);
                this.setState({
                    getind: index
                })

                console.log('getnid-index', index)
            }
            )
        console.log('getnid', this.props.match.params.nid)
    }
    handlepageclick1(action) {
        console.log('clicked', this.state.getind)
        if (action === "next") {
            this.setState({
                getind: this.state.getind + 1,
                refer: [],
                journal: [],
                inst: [],
                descr: [],
                authors: [],
                affl: []
            }, () => {
                this.props.history.push('/cis_publication/' + this.state.newnids[this.state.getind])
                this.apicall(this.state.newnids[this.state.getind])
            })
            this.clearinc()
            this.topFunction()
            localStorage.setItem('indexof', JSON.stringify(this.state.index1 + 1))
        }
        else if (action === "prev") {
            this.setState({
                getind: this.state.getind - 1,
                refer: [],
                journal: [],
                inst: [],
                descr: [],
                authors: [],
                affl: []
            }, () => {
                this.props.history.push('/cis_publication/' + this.state.newnids[this.state.getind])
                this.apicall(this.state.newnids[this.state.getind])
            })
            this.clearinc()
            this.topFunction()
        }
    }

    high2(strg) {
        let keyarr = []
        var keyarr2 = this.state.queryobj.search === "true" ? this.state.keyarr : []
        console.log(this.state.keyarr, 'regex3');
        if (this.state.queryobj.search === "true") {
            for (let i = 0; i < keyarr2.length; i++) {
                // if (keyarr2[i].includes('"'))
                //     keyarr.push('\\b' + keyarr2[i].replace(/,/g, "").replace(/[()]/g, '').split('.').join(" ").replace(/["]+/g, '') + '\\b')
                // else
                keyarr.push(keyarr2[i].replace(/,/g, "").replace(/[()]/g, '').split('.').join(" ").replace(/["]+/g, '').replace(/[\u201C\u201D]/g, '"'))
            }
        }
        console.log(keyarr.join('|'), "high223")
        var querystr = keyarr.join("|");
        var result = strg
        var reg = new RegExp(querystr, 'gi');

        var final_str = result.replace(reg, function (str) { return '<mark>' + str + '</mark>' });
        return final_str
    }

    gethighlight(data) {
        return <Highlighter
            highlightClassName="YourHighlightClass"
            searchWords={this.state.queryobj.search === "true" ? this.state.keyarr : []}
            autoEscape={true}
            textToHighlight={data}
        />
    }

    callnext(nid) {
        this.props.history.push('/publication/' + nid + '?search=true')
    }

    setnextpage() {
        this.setState({
            keyword: JSON.parse(localStorage.getItem('searchkey')),
            sarray: JSON.parse(localStorage.getItem('sarray')),
            index: JSON.parse(localStorage.getItem('sarray')).indexOf(this.state.nid),
        })
    }

    checknext1() {
        let from = this.state.getind
        console.log(from, "check")
        if (from > this.state.newnids.length) {
            this.setState({
                nextnid: false
            })
        }
    }

    checkprev1() {
        let ind = this.state.getind
        console.log(ind, "check")

        if (ind === 1) {
            this.setState({
                prevnid: false
            })
        }
    }



    tooltip(txt) {
        this.setState({
            tooltext: txt,
            tooltip: true
        })
    }

    openpopmail() {

        this.setState({
            mailpop: !this.state.mailpop,
            advance: false,
            advancearray: []
        })
    }
    fillalert(msg) {
        this.topFunction()
        this.setState({
            filltext: msg,
            fillalert: true
        })
        setTimeout(
            function () {
                this.setState({
                    fillalert: null
                })
            }
                .bind(this),
            3000
        );
    }


    printTest2(op, mail) {

        if (op === "mail") {
            {
                let ere = new RegExp("^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}")
                if (mail) {
                    if (ere.test(mail) == true)
                        this.print(op, mail)
                    else
                        this.fillalert('Please enter a valid Email ID')
                }
                else
                    this.fillalert('Please enter the Email ID')
            }

        }
        else {

            this.print(op, "dummy")
        }

    }
    print(op, mail) {
        if (op === "save" || op === "print") {

        }
        else {

        }
        let ids = [this.props.match.params.nid]

        const formbody = {
            "email": mail,
            "operation": op === "save" || op === "print" ? "save" : op,
            "id": '[' + ids.join() + ']'
        }
        this.setState({
            load: true,

        })

        Axios(BASE + 'notification/export', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            data: formbody
        })

            .then((res) => {

                console.log(res)
                if (op === "save") {
                    this.setState({
                        load: false,
                        exportid: [],
                        selectall: false
                    })
                    window.open('https://' + res.data, "_self")
                    // window.open('http://'+res.data)

                }
                else if (op === "print") {
                    setTimeout(
                        function () {
                            this.setState({ load: false });
                        }
                            .bind(this),
                        5000
                    );

                    printJS('https://' + res.data)
                    this.setState({
                        exportid: [],
                        selectall: false
                    })
                }
                else
                    this.fillalert('Mail Sent')
                this.setState({
                    mailpop: false,
                    load: false,
                    exportid: [],
                    selectall: false,
                    mailpdf: ''
                })
            })
            .catch((err) => {
                console.log(err)
                this.fillalert('Please enter valid details')

            })


    }

    exportmail(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }



    render() {
        console.log('subdatas', this.state.sub_data)
        console.log('includeddata', this.state.included_data)
        return (
            <div className='institutions eventpage sub_work' id="pub-details">
                <Header />
                <div className='top-contents container'>
                    <div className="crumbs">
                        <Link to='/'>Home</Link> / <Link to='/cis_publication'> Publication</Link> {this.state.sub_data ? "/ " + this.state.sub_data.title : ""}
                    </div>
                    {/* <TopBar data={'data1'} /> */}
                </div>
                {this.state.fillalert ?
                    <div className={this.state.filltext === 'Mail Sent' ? "fill-alert fill-success" : "fill-alert"}>{this.state.filltext}</div> : ''}
                {this.state.loader ? <Loader color="#165E84" loaded={false} className="spinner" /> : ''}
                {this.state.load ?
                    <div className='loading'>
                        <img src={load} alt='load' />
                    </div>
                    : ''}
                <div className="pub_container container">

                    <body className="wiki" >
                        <div className="main-content">
                            <div>
                                <div className="row">
                                    <div className="node-wiki node">
                                        <div className="group-middle">
                                            <div className="field-name-title">
                                                <Link className='back-search' to='/cis_publication'><span><img src={back} /></span> Back to Publication</Link>
                                                <div className='booktitle_rea'>{this.state.sub_data ?
                                                    ReactHtmlParser(this.high2(this.state.sub_data.title))
                                                    // this.getHighlightedText(this.state.sub_data.title)
                                                    : ''}
                                                </div>
                                                <div className="field-name-metadata-books">
                                                    <div className="field-item even" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', position: 'relative' }}>
                                                        <div className="view-wiki">
                                                            {this.state.sub_data ?
                                                                <ul>
                                                                    {this.state.authors.length != 0 ?
                                                                        <li className="first" style={{ display: 'flex', flexDirection: 'row', marginBottom: '0', paddingBottom: '0' }}>

                                                                            <div className="field-name-field-body author-field">
                                                                                {this.state.authors.map((include, index) => {
                                                                                    let faculty = this.state.faculty ? this.state.faculty.filter(x => {
                                                                                        let id = x.relationships.field_author_faculty.data.filter(y => {
                                                                                            if (y.id == include.id)
                                                                                                return y.id
                                                                                        })
                                                                                        if (id.length)
                                                                                            return id[0].id
                                                                                    }) : ""
                                                                                    return (
                                                                                        <div className='references author-name gray-text'>
                                                                                            {faculty.length ? <Link to={`/faculty/${faculty[0].attributes.title.replace(/\W+(?!$)/g, '-')}?nid=${faculty[0].attributes.drupal_internal__nid}`}>{ReactHtmlParser(this.high2(include.attributes.title))}</Link> : <span className="gray-text">{ReactHtmlParser(this.high2(include.attributes.title))}</span>}{this.state.authors.length - 1 !== index ? ' ; ' : ''}
                                                                                        </div>
                                                                                    )
                                                                                })
                                                                                }
                                                                            </div>
                                                                        </li> : ''}

                                                                    {this.state.affl ?
                                                                        <li className="first" style={{ display: 'flex', flexDirection: 'row', marginTop: '0', paddingTop: '0' }}>
                                                                            <div className="field-name-field-body author-field">
                                                                                <div className='references author-name'>
                                                                                    {this.state.affl.attributes ? <Link to={this.inst(this.state.affl.attributes.drupal_internal__tid, this.state.affl.attributes.name.replace(/\//g, "-"))}>{ReactHtmlParser(this.high2(this.state.affl.attributes.name))}</Link> : ''}
                                                                                </div>
                                                                            </div>
                                                                        </li> : ''}
                                                                    {this.state.publication_type ?
                                                                        this.state.publication_type === "Articles" ?
                                                                            <div style={{
                                                                                alignItems: 'center', display: "contents"
                                                                            }}>
                                                                                {this.state.journal.length !== 0 ?
                                                                                    this.state.journal.map((include, index) => {
                                                                                        return (
                                                                                            <Link className='italic' to={this.journlink(include.attributes.drupal_internal__nid, include.attributes.title.replace(/\//g, "-"), 'journal_nodes')}>{ReactHtmlParser(this.high2(include.attributes.title))}</Link>
                                                                                        )
                                                                                    })

                                                                                    : ''}
                                                                                {this.state.affl ?
                                                                                    <span className='references author-name'>
                                                                                        {this.state.affl.attributes ? <Link to={this.inst(this.state.affl.attributes.drupal_internal__tid, this.state.affl.attributes.name.replace(/\//g, "-"))}>{ReactHtmlParser(this.high2(this.state.affl.attributes.name))}</Link> : ""}
                                                                                        {/* {this.state.affl.length - 1 !== index ? ' ' : ''} */}
                                                                                    </span>
                                                                                    : ''
                                                                                }
                                                                                {this.state.sub_data.field_volume ? ', ' + this.state.sub_data.field_volume : ''}{this.state.sub_data.field_number ? '(' + this.state.sub_data.field_number + ')' : ''}{this.state.sub_data.field_year ? ', ' + this.state.sub_data.field_year : ''}{this.state.sub_data.field_pages ? ', ' + this.state.sub_data.field_pages : ''}
                                                                            </div>
                                                                            : ''
                                                                        : ''}
                                                                    {this.state.publication_type ?
                                                                        this.state.publication_type === "Books" ?
                                                                            <div style={{
                                                                                alignItems: 'center', display: "contents"
                                                                            }}>
                                                                                {this.state.sub_data.field_place ? this.state.sub_data.field_place + ':' : ''}{this.state.publisher ?

                                                                                    this.state.publisher.attributes ? <Link to={this.inst(this.state.publisher.attributes.drupal_internal__tid, this.state.publisher.attributes.name.replace(/\//g, "-"))}> {ReactHtmlParser(this.high2(this.state.publisher.attributes.name))}</Link>

                                                                                        : '' : ""}{this.state.sub_data.field_year ? ', ' + this.state.sub_data.field_year : ''}{this.state.sub_data.field_pages && this.state.sub_data.field_pages !== 'N/A' ? ', ' + this.state.sub_data.field_pages : ''}{this.state.sub_data.field_isbn && this.state.sub_data.field_isbn != 'N/A' ? ', ' + this.state.sub_data.field_isbn : ''}
                                                                                { }
                                                                            </div>
                                                                            : ''
                                                                        : ''}

                                                                    {this.state.publication_type ?
                                                                        this.state.publication_type === "Book Chapters" ?
                                                                            <div style={{
                                                                                alignItems: 'center', display: "contents"
                                                                            }}>
                                                                                {this.state.relauthor ? this.state.relauthor.length !== 0 ?
                                                                                    this.state.relauthor.map((rel, index) => {
                                                                                        return (
                                                                                            <Link to={this.journlink(rel.drupal_internal__nid, rel.title.replace(/\//g, "-"), 'author_nodes')}>{rel.title + '; '}</Link>
                                                                                        )
                                                                                    })
                                                                                    : '' : ''}
                                                                                {this.state.related.length ?
                                                                                    this.state.related.map((include, index) => {
                                                                                        if (index === 0)
                                                                                            return (
                                                                                                <Link to={this.journlink(include.attributes.drupal_internal__nid, include.attributes.title.replace(/\//g, "-"), 'journal_nodes')}>{include.attributes.title + ', '}</Link>
                                                                                            )
                                                                                    })
                                                                                    : ''}

                                                                                {this.state.sub_data.field_place ? this.state.sub_data.field_place + ': ' : ''}
                                                                                {this.state.publisher.length ?
                                                                                    this.state.publisher.map((include, index) => {
                                                                                        return (
                                                                                            <Link to={this.inst(include.attributes.drupal_internal__tid, include.attributes.name.replace(/\//g, "-"))}>{ReactHtmlParser(this.high2(include.attributes.name))}</Link>
                                                                                        )
                                                                                    }) : ''}{this.state.sub_data.field_year ? ', ' + this.state.sub_data.field_year : ''}{this.state.sub_data.field_pages ? ', ' + this.state.sub_data.field_pages : ''}{this.state.sub_data.field_isbn && this.state.sub_data.field_isbn != "N/A" ? ', ' + this.state.sub_data.field_isbn : ""}
                                                                            </div>
                                                                            : ''
                                                                        : ''}

                                                                    {this.state.publication_type ? this.state.publication_type === "Conferences" ?
                                                                        <div style={{
                                                                            alignItems: 'center', display: "contents"
                                                                        }}>
                                                                            {this.state.affl.length != 0 ?
                                                                                this.state.affl.map((include, index) => {
                                                                                    return (
                                                                                        <Link to={this.inst(include.attributes.drupal_internal__tid, include.attributes.name.replace(/\//g, "-"))}>{ReactHtmlParser(this.high2(include.attributes.name))}</Link> + this.state.affl.length - 1 !== index ? ' ' : ''
                                                                                    )
                                                                                })
                                                                                : ''}

                                                                            {this.state.conf.length != 0 ?
                                                                                this.state.conf.map((include, index) => {
                                                                                    return (
                                                                                        this.state.queryobj.search === "true" ?
                                                                                            <Link className='italic' to={this.journlink(include.attributes.drupal_internal__nid, include.attributes.title.replace(/\//g, "-"), 'conference_nodes')}>{ReactHtmlParser(this.high2(include.attributes.title))}</Link> :
                                                                                            <Link className='italic' to={this.journlink(include.attributes.drupal_internal__nid, include.attributes.title.replace(/\//g, "-"), 'conference_nodes')}>{ReactHtmlParser(this.high2(include.attributes.title))}</Link>
                                                                                    )
                                                                                })

                                                                                : ''}
                                                                            {this.state.conf.length != 0 ? this.state.conf[0].attributes.field_city ? ', ' + this.state.conf[0].attributes.field_city : '' : ''}{this.state.sub_data.field_country ? ' - ' + ReactHtmlParser(getName(this.state.sub_data.field_country)) : ""}

                                                                            {this.state.sub_data.field_year ? ', ' + this.state.sub_data.field_year : ''}
                                                                        </div> : '' : ''
                                                                    }

                                                                    {this.state.publication_type ? this.state.publication_type === "Thesis" ?
                                                                        <div style={{
                                                                            alignItems: 'center', display: "contents"
                                                                        }}>
                                                                            {this.state.inst.map((include, index) => {
                                                                                return (
                                                                                    <Link to={this.inst(include.attributes.drupal_internal__tid, include.attributes.name)}>{ReactHtmlParser(this.high2(include.attributes.name))}</Link>
                                                                                )
                                                                            })
                                                                            }{this.state.sub_data ? this.state.sub_data.field_degree ? this.state.sub_data.field_degree !== 'N/A' ?
                                                                                ', ' + this.state.sub_data.field_degree.replace(/\.+$/, "")
                                                                                : '' : '' : ''}{this.state.sub_data.field_year ? ', ' + this.state.sub_data.field_year : ''}{this.state.sub_data.field_pages ? ', ' + this.state.sub_data.field_pages : ''}
                                                                        </div>
                                                                        : '' : ''}
                                                                </ul> : ''}
                                                        </div>
                                                    </div>
                                                    <div className='data-with-img ' style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between', marginTop: "1%" }}>
                                                        <div>
                                                            {this.state.sub_data && this.state.sub_data.body ? <div className="field field-name-body field-type-text-with-summary field-label-hidden">
                                                                <div className="field-items">
                                                                    {this.state.sub_data ?
                                                                        <div className="field-item even sub-body-text" property="content:encoded">
                                                                            {this.state.sub_data.body ?
                                                                                this.state.queryobj.search === "true" ?
                                                                                    ReactHtmlParser(this.high2(this.state.sub_data.body.processed)) :
                                                                                    ReactHtmlParser(this.state.sub_data.body.processed)

                                                                                : ''}
                                                                        </div> : ''}
                                                                </div>
                                                            </div> : ''}
                                                        </div>
                                                    </div>
                                                    {this.state.booktitle.length != 0 ? <div>
                                                        <h4>Book Title</h4>

                                                        {this.state.booktitle.map((include, index) => {
                                                            return (
                                                                <div className='references'>
                                                                    <Link to={this.journlink(include.attributes.drupal_internal__nid, include.attributes.title.replace(/\//g, "-"), 'journal_nodes')}>{ReactHtmlParser(this.high2(include.attributes.title))}</Link>
                                                                </div>
                                                            )
                                                        })
                                                        }


                                                    </div> : ''}
                                                    {this.state.descr.length != 0 ? <div>
                                                        <h4>Descriptors</h4>

                                                        {this.state.descr.map((include, index) => {
                                                            return (
                                                                <div className='references'>
                                                                    <Link to={this.inst(include.attributes.drupal_internal__tid, include.attributes.name.replace(/\//g, "-"))}>{ReactHtmlParser(this.high2(include.attributes.name))}</Link>
                                                                </div>
                                                            )
                                                        })
                                                        }

                                                    </div> : ''}
                                                    {this.state.refernew && this.state.refernew.length != 0 ? <div className="references">
                                                        <h4>References</h4>

                                                    </div>
                                                        : ''}
                                                    <div className="search_block">
                                                        <ol className="search-results node-results">

                                                            {this.state.refernew && this.state.refernew.length != 0 ? this.state.refernew.map((result, index) => {
                                                                return (
                                                                    <div className="searchresultdiv">
                                                                        {this.state.login ?
                                                                            <div
                                                                                style={{ backgroundColor: this.checkexport(result._source.nid[0]) ? '#165e84' : 'white' }}
                                                                                onClick={() => this.exportid(result._source.nid[0])} className="selct_box">
                                                                            </div> : ''}
                                                                        <div style={{ width: this.state.login ? '' : '100%' }}>
                                                                            <li>
                                                                                <Link target={this.state.login ? "_blank" : "_self"} to={this.goto(result._source.nid[0], result._source.publications_label[0], result._source.title[0])}>{result._source.title[0]}</Link>


                                                                                <p style={{ color: '#b0b0b0' }}>

                                                                                </p>
                                                                            </li>
                                                                            <div className='searchauthors'>
                                                                                {result._source.author_label ? result._source.author_label.map((author, index) => {
                                                                                    return <div className="author">
                                                                                        {ReactHtmlParser(author)}
                                                                                    </div>
                                                                                }) : ''}
                                                                            </div>
                                                                            {result._source.journal_label && result._source.journal_label.length != 0 ? result._source.journal_label.map((author, index) => {
                                                                                return <div className="author">
                                                                                    {ReactHtmlParser(author)}
                                                                                </div>
                                                                            }) : ''}
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }) : <ul>
                                                                <li>{this.state.notxt}</li>
                                                            </ul>}

                                                        </ol>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="searchpage">
                                                <div className="sidemenu inner-pub-side">

                                                    {this.state.pdf.length !== 0 ? this.state.pdf ?
                                                        this.state.pdf.map((item, ind) => {
                                                            return (
                                                                <a className="pdf_pub" href={item} target="_blank">
                                                                    <div>
                                                                        <span><img src={pdf} /></span>
                                                                        <span className='download'>Download PDF</span>
                                                                        {/* <img className="pdf" src={pdf} /> */}
                                                                    </div>
                                                                </a>
                                                            )
                                                        })
                                                        : '' : ''}

                                                    {this.state.publication_type && this.state.img ? this.state.publication_type === "Books" || this.state.publication_type === "Conferences" ?
                                                        <img src={this.state.img} />
                                                        : '' : ''}
                                                    {this.state.journal_img.length !== 0 ?
                                                        this.state.journal_img.map((image, ind) => {
                                                            return (
                                                                <img id="journal_img" key={ind} src={image} />
                                                            )
                                                        })
                                                        : ''}
                                                    {!this.state.loader ?
                                                        <div className="sav-print">
                                                            <div onClick={() => this.printTest2("save")}>Save</div>
                                                            <div onClick={() => this.printTest2("print")}>Print</div>
                                                            <div onClick={() => this.openpopmail()}>Email</div>
                                                        </div> : ''}
                                                    {this.state.mailpop ?
                                                        <div id="sub-mail-pop" className="mailpop">
                                                            <input value={this.state.mailpdf} onChange={(e) => this.exportmail(e)} name="mailpdf" />
                                                            <button onClick={() => this.printTest2("mail", this.state.mailpdf)}>Send</button>
                                                        </div>
                                                        : ''}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </body>
                </div>
                <ul style={{ margin: 0 }} className="public-pagin">
                    <span>
                        <span style={{ pointerEvents: this.state.getind > 0 ? '' : 'none', color: this.state.getind > 0 ? '#165E84 ' : '', fontWeight: this.state.getind > 0 ? '500' : '', cursor: this.state.getind > 0 ? 'pointer' : 'not-allowed' }} onClick={() => this.handlepageclick1('prev')} class={this.state.getind > 0 ? "arrow prev-arrow" : "arrow prev-arrow disabled"}></span>
                        <p onClick={() => this.handlepageclick1('prev')} style={{ color: this.state.getind > 0 ? '#165E84 ' : '', cursor: this.state.getind > 0 ? 'pointer' : 'not-allowed' }} >Previous Publication</p>
                    </span>
                    <span>
                        <p style={{ color: this.state.getind < (this.state.newnids.length - 1) ? '#165E84 ' : '', cursor: this.state.getind < (this.state.newnids.length - 1) ? 'pointer' : 'not-allowed' }} onClick={() => this.handlepageclick1('next')}>Next Publication</p>
                        <span style={{ pointerEvents: this.state.getind < (this.state.newnids.length - 1) ? '' : 'none', color: this.state.getind < (this.state.newnids.length - 1) ? '#165E84 ' : '', fontWeight: this.state.getind < (this.state.newnids.length - 1) ? '500' : '', cursor: this.state.getind < (this.state.newnids.length - 1) ? 'pointer' : 'not-allowed' }} onClick={() => this.handlepageclick1('next')} class={this.state.getind < (this.state.newnids.length - 1) ? "arrow" : "arrow disabled"}></span>
                    </span>

                </ul>
                <div><Footer /></div>
            </div>
        )
    }
}

export default Innerbook;